import { GetterTree } from 'vuex';
import { IImportProgress } from '@/dealroom/create-page/importer/types/import-progress';
import { EImportStatus } from '@/dealroom/create-page/importer/types/enums/import-status';
import { EImportType } from '@/dealroom/create-page/importer/types/enums/import-type';
import { ImporterHelper } from '@/dealroom/create-page/importer/helpers/importer.helper';
import { IImporterState } from '@/dealroom/create-page/importer/store/importer.types';
import { EImporterGetter } from '@/dealroom/create-page/importer/store/importer.constants';
import { RootState } from '@/store/store';
import { translate } from '@/helpers/translation.helper';

export const getters: GetterTree<IImporterState, RootState> = {
  [EImporterGetter.Progress](state: IImporterState): IImportProgress {
    if (!state.importing) {
      return null;
    }
    if (state.imported) {
      return {
        message: translate('done').toString(),
        percentage: 100,
        status: EImportStatus.Completed,
      };
    }
    const { type, error } = state.importData;
    if (error) {
      return ImporterHelper.getErrorProgress(type, error);
    }
    switch (type) {
      case EImportType.Template:
        return ImporterHelper.getTemplateProgress();
      case EImportType.File:
        return ImporterHelper.getFileProgress(
          state.importData,
          state.importedPages.length,
          state.fileImport.pageCount
        );
      case EImportType.WordDocument:
        return ImporterHelper.getWordDocumentProgress(
          state.importData,
          state.importedPages.length,
          state.fileImport.pageCount
        );
      case EImportType.GoogleDocs:
        return ImporterHelper.getGoogleDocsProgress(
          state.importData,
          state.importedPages.length,
          state.importedDocument,
          state.fileImport.pageCount
        );
      case EImportType.GoogleDrive:
        return ImporterHelper.getGoogleDriveProgress(
          state.importData,
          state.importedPages.length,
          state.fileImport.pageCount
        );
    }
  },
  [EImporterGetter.ShowWordMergeModal](state: IImporterState): boolean {
    return !!state.wordMerge?.missing?.length;
  },
};
